export default "__VITE_ASSET__CNheWVnO__"